/* eslint-disable complexity */
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Box } from 'carbon-react/lib/components/box/box.component';
import Button from 'carbon-react/lib/components/button';

import { ActiveMode } from '../../types';

interface Props {
  handleSave: () => void;
  handleClose: () => void;
  handleInitialClick: (mode: ActiveMode) => void;
  activeMode?: ActiveMode;
  isCOAEditable: boolean;
  isUpdatingStructure?: boolean;
}

export const ActionButtons = ({
  handleSave,
  handleClose,
  handleInitialClick,
  activeMode,
  isCOAEditable,
  isUpdatingStructure
}: Props) => {
  const renderButtons = () => {
    switch (activeMode) {
      case ActiveMode.REORDERING:
        return (
          <>
            <Button buttonType="primary" mr={1} onClick={handleSave} disabled={isUpdatingStructure}>
              <FormattedMessage id="predict.save_new_order" defaultMessage="Save new order" />
            </Button>
            <Button buttonType="secondary" onClick={handleClose} disabled={isUpdatingStructure}>
              <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
            </Button>
          </>
        );
      default:
        return (
          <>
            <Button buttonType="secondary" mr={1} onClick={() => handleInitialClick(ActiveMode.REORDERING)}>
              <FormattedMessage id="common.reorder" defaultMessage="Reorder" />
            </Button>
            <Button buttonType="secondary" mr={1} onClick={() => handleInitialClick(ActiveMode.RECLASSIFYING)}>
              <FormattedMessage id="common.reclassify" defaultMessage="Reclassify" />
            </Button>
            <Button buttonType="secondary" onClick={() => handleInitialClick(ActiveMode.CREATE_GROUP)}>
              <FormattedMessage id="common.create_group" defaultMessage="Create group" />
            </Button>
          </>
        );
    }
  };

  return <Box display="flex">{isCOAEditable ? renderButtons() : null}</Box>;
};
